import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { valByKeyWithDot } from '../../../../helpers/value'
import {
  deleteSavedCriteria,
  getSavedCriteria,
  getSavedCriterias,
} from './thunk'

const initialState = {
  filter: {
    keyword: '',
    from: null,
    to: null,
    By: null,
    Direction: null,
    page: 1,
    pageSize: 20,
  },

  criteriaIds: [],
  criteriaById: {},
  totalRecords: 0,

  selectedCriteria: null,

  loading: {
    criterias: true,
    selectedCriteria: true,
  },
}

const name = 'tool/screening/savedCriteria'

export const slice = createSlice({
  name,
  initialState,
  reducers: {
    resetStore: () => initialState,
    changeFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload }
    },
    changeCriteriaData: (state, action) => {
      const { id, key, value } = action.payload
      if (state.criteriaById[id]) state.criteriaById[id][key] = value
      state.selectedCriteria[key] = value
    },
  },
  extraReducers: (builder) => {
    // getSavedCriterias
    builder.addCase(getSavedCriterias.pending, (state) => {
      state.loading.criterias = true
    })
    builder.addCase(getSavedCriterias.fulfilled, (state, action) => {
      const { data, totalRecords } = action.payload
      state.criteriaIds = data.map((item) => item.id)
      state.criteriaById = keyBy(data, 'id')
      state.totalRecords = totalRecords
      state.loading.criterias = false
    })
    builder.addCase(getSavedCriterias.rejected, (state, action) => {
      state.loading.criterias = action.payload.loading
    })
    // getSavedCriteria
    builder.addCase(getSavedCriteria.pending, (state) => {
      state.loading.selectedCriteria = true
    })
    builder.addCase(getSavedCriteria.fulfilled, (state, action) => {
      state.selectedCriteria = action.payload
      state.loading.selectedCriteria = false
    })
    builder.addCase(getSavedCriteria.rejected, (state, action) => {
      state.selectedCriteria = null
      state.loading.selectedCriteria = action.payload.loading
    })
    // deleteSavedCriteria
    builder.addCase(deleteSavedCriteria.pending, (state) => {})
    builder.addCase(deleteSavedCriteria.fulfilled, (state, action) => {
      const criteriaId = action.meta.arg.Id
      if (state.selectedCriteria?.id === criteriaId) {
        state.selectedCriteria = null
      }
    })
    builder.addCase(deleteSavedCriteria.rejected, (state, action) => {})
  },
})

export const selectFilter = (type) => (state) =>
  type ? state[slice.name].filter[type] : state[slice.name].filter

export const selectLoading = (type) => (state) =>
  state[slice.name].loading[type]

export const selectCriteriaIds = (callback) => (state) => {
  const data = state[slice.name].criteriaIds
  return callback ? callback(data) : data
}
export const selectCriteriaById = (id, attr) => (state) =>
  valByKeyWithDot(state[slice.name].criteriaById[id], attr)
export const selectTotalRecords = (state) => state[slice.name].totalRecords

export const selectSelectedCriteria = (callback) => (state) => {
  const data = state[slice.name].selectedCriteria
  return callback ? callback(data) : data
}

export const { resetStore, changeFilter, changeCriteriaData } = slice.actions

register(slice.name, slice.reducer)
